import { v4 as uuidv4 } from 'uuid';
import { addMinutes, isBefore } from 'date-fns';
import Cookies from 'js-cookie';
import { getSuperProperties } from './eventSuperProperties';
import { eventTracker } from './eventTracker';
import getContext from '../utilities/get-context';
import analyticsEvents from './analyticsEvents';
import { COOKIES } from '../constants/cookies';

const SESSION_STORE_NAME = 'motionarray_eventTrackingSession';
const IS_VISIT_STORE_NAME = 'motionarray_isVisit';
const SESSION_MINUTES_DURATION = 30;

function localStorageSetEventData(eventStoreName, eventTrackingSession) {
  try {
    getContext().localStorage.setItem(eventStoreName, JSON.stringify(eventTrackingSession));
    return true;
  } catch (error) {
    console.error(`Failed to save ${eventStoreName} in local storage`, error);
  }

  return false;
}

function getCookieByKey(key) {
  const data = typeof window !== 'undefined' && Cookies.get(key);
  if (!data) {
    return undefined;
  }

  return data;
}

export function localStorageGetIsVisit() {
  return getDataByKeyFromLocalStorage(IS_VISIT_STORE_NAME);
}

export function localStorageSetVisited() {
  return localStorageSetEventData(IS_VISIT_STORE_NAME, false);
}

function getDataByKeyFromLocalStorage(key) {
  const eventData = getContext().localStorage.getItem(key);

  if (!eventData) {
    return undefined;
  }

  return JSON.parse(eventData);
}

export function trackVisitEvent() {
  const superProperties = getSuperProperties();

  eventTracker(analyticsEvents.visit, {
    ...superProperties,
  });
}

export const hasActiveUserSession = () => {
  return getCookieByKey(COOKIES.NAMES.USER_SESSION);
};

const setupUserSession = () => {
  const sessionID = uuidv4();

  Cookies.set(COOKIES.NAMES.USER_SESSION, sessionID, {
    expires: addMinutes(new Date(), SESSION_MINUTES_DURATION),
  });

  // Mark that a new session is being created and a visit event should be sent once it's finalized
  localStorageSetEventData(IS_VISIT_STORE_NAME, true);

  return sessionID;
};

const extendSessionID = () => {
  const sessionID = Cookies.get(COOKIES.NAMES.USER_SESSION);
  if (sessionID) {
    Cookies.set(COOKIES.NAMES.USER_SESSION, sessionID, {
      expires: addMinutes(new Date(), SESSION_MINUTES_DURATION),
    });
  }
  return sessionID;
};

/**
 * If no session exists, create one.
 * If the session expired, make a new one.
 * If an active session exists, update its timestamp.
 * Return the session.
 */
export function touchUserSession() {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const userSession = getCookieByKey(COOKIES.NAMES.USER_SESSION);

  if (!userSession) {
    localStorage.removeItem(SESSION_STORE_NAME);
    return setupUserSession();
  }

  return extendSessionID();
}

export function getSessionId() {
  return touchUserSession();
}
